module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"qualificationParameters":"Qualification parameters"},"fr":{"qualificationParameters":"Paramètres de la qualification"}}')
  delete Component.options._Ctor
}
